import { useState } from 'react';

export function useStepPreviews() {
  const [actionPreview, setActionPreview] = useState<{
    workflowDefinitionId: string;
    stepLabel: string;
  } | null>(null);
  const [agentPreview, setAgentPreview] = useState<{
    agentDefinitionId: string;
    stepLabel: string;
  } | null>(null);
  const [emailRulePreview, setEmailRulePreview] = useState<{
    emailRuleIds: string[];
    stepLabel: string;
  } | null>(null);
  const handleViewAction = (
    workflowDefinitionId: string,
    stepLabel: string,
  ) => {
    setActionPreview({ workflowDefinitionId, stepLabel });
  };
  const handleViewAgent = (agentDefinitionId: string, stepLabel: string) => {
    setAgentPreview({ agentDefinitionId, stepLabel });
  };
  const handleViewEmailRules = (emailRuleIds: string[], stepLabel: string) => {
    setEmailRulePreview({ emailRuleIds, stepLabel });
  };
  return {
    actionPreview,
    setActionPreview,
    handleViewAction,
    agentPreview,
    setAgentPreview,
    handleViewAgent,
    emailRulePreview,
    setEmailRulePreview,
    handleViewEmailRules,
  };
}
